import React from "react";

export default function ModalShowHistoryDetail({ open, loadComments, onClose }) {
  const htmlDecode = (input) => {
    const a = document.createElement('div');
    a.innerHTML = input;
    return a.childNodes.length === 0 ? "" : a.childNodes[0].nodeValue;
  }
  if (!open) return null;
  return (
    <div onClick={onClose} className="overlayHistory">
      <div className="modalContainerShowHistory">
        <h3
          style={{
            color: "gray",
            alignSelf: "center",
            marginTop: "12px",
            fontSize: 22,
          }}
        >
          Content
        </h3>
        <div className="ContainerHistoryDetailModal">
          <div dangerouslySetInnerHTML={{ __html: htmlDecode(loadComments) }}></div>
        </div>
      </div>
    </div>
  );
}